import Header from "@/components/Header";
import AnimalList from "@/components/AnimalList";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const AnimalListPage = () => {
  return (
    <div className="min-h-screen">
      <SEOHead 
        title="동물 모델 목록 - Central TG | JAX® Transgenic 마우스 검색"
        description="Jackson Laboratory의 다양한 transgenic 마우스 모델을 검색하세요. NOD/SCID, C57BL/6J, NOD 등 암·면역·신경과학 연구용 모델 제공."
        keywords="JAX 마우스 목록, transgenic 모델 검색, NOD/SCID 마우스, C57BL/6J, 실험동물 카탈로그, 유전자변형 마우스 종류, 연구용 마우스, 면역결핍 마우스"
        canonical="https://centraltg.co.kr/animal-list"
      />
      <Header />
      <AnimalList />
      <Footer />
    </div>
  );
};

export default AnimalListPage;